module.exports = __webpack_public_path__ + "images/91a9a69f86a8c20440c5ccf92a50433a.jpg";